import { Grid, TableCell, TableRow, Typography, useMediaQuery } from '@mui/material';

interface IGridOptionItem {
  label: string;
  originalPrice?: string | number;
  incentive?: string | number;
  finalPrice: string | number;
  color?: string;
}

// separate the Header and Row components so styles can be consistent, but similar
const Header = ({ label, originalPrice, incentive, finalPrice, color }: IGridOptionItem) => {
  //Updated to 899px to avoid the transition that was breaking at exactly 900px
  const isMobile = useMediaQuery(`(max-width: 899px)`);
  if (isMobile) return null;
  return (
    <Grid display={'flex'} justifyContent={'space-around'} alignItems={'center'} container>
      <Grid item xs={12} sm={3}>
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            fontWeight: 600,
            color: color ?? '#000'
          }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            textAlign: 'center',
            fontWeight: 600,
            color: color ?? '#000'
          }}
        >
          {originalPrice}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            textAlign: 'center',
            fontWeight: 600,
            color: color ?? '#000'
          }}
        >
          {incentive}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            textAlign: 'center',
            fontWeight: 600,
            color: color ?? '#000'
          }}
        >
          {finalPrice}
        </Typography>
      </Grid>
    </Grid>
  );
};
const Row = ({ label, originalPrice = '', incentive = '', finalPrice, color }: IGridOptionItem) => {
  const isMobile = useMediaQuery(`(max-width: 899px)`);

  const padding = isMobile ? 0 : 3;

  return (
    <Grid container>
      <Grid item xs={12} md={3}>
        <Typography sx={{ whiteSpace: 'break-spaces', fontWeight: 600, color: color ?? '#000' }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} pr={padding} textAlign={'right'}>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {isMobile && originalPrice ? 'Original Price: ' : null}
        </Typography>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {originalPrice}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} pr={padding} textAlign={'right'}>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {isMobile && incentive ? 'Incentive: ' : null}
        </Typography>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {incentive}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} pr={padding} textAlign={'right'}>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {isMobile && finalPrice ? 'Total Price: ' : null}
        </Typography>
        <Typography component="span" sx={{ textAlign: 'right', color: color ?? '#000' }}>
          {finalPrice}
        </Typography>
      </Grid>
    </Grid>
  );
};

const PrintRow = ({
  label,
  originalPrice = '',
  incentive = '',
  finalPrice,
  color
}: IGridOptionItem) => {
  return (
    <TableRow sx={{ border: 'none' }}>
      <TableCell sx={{ fontWeight: 600, border: 'none', padding: 0, color: color ?? '#000' }}>
        {label}
      </TableCell>
      <TableCell
        sx={theme => ({
          textAlign: 'right',
          border: 'none',
          padding: 0,
          paddingRight: theme.spacing(0.5),
          color: color ?? '#000'
        })}
      >
        {originalPrice}
      </TableCell>
      <TableCell
        sx={theme => ({
          textAlign: 'right',
          border: 'none',
          padding: 0,
          paddingRight: theme.spacing(0.5),
          color: color ?? '#000'
        })}
      >
        {incentive}
      </TableCell>
      <TableCell
        sx={theme => ({
          textAlign: 'right',
          border: 'none',
          padding: 0,
          paddingRight: theme.spacing(0.5),
          color: color ?? '#000'
        })}
      >
        {finalPrice}
      </TableCell>
    </TableRow>
  );
};
export const GridOption = {
  Header: Header,
  Row: Row,
  PrintRow: PrintRow
};
